module.exports = __webpack_public_path__ + "assets/img/enterprise-phone-1.f69bab59.png";